import type VectorSource from 'ol/source/Vector'
import type VectorLayer from 'ol/layer/Vector'
import type Feature from 'ol/Feature'
import type Geometry from 'ol/geom/Geometry'

export const findFeature = (
  layer: VectorLayer<VectorSource>,
  id: string,
): Feature<Geometry> | undefined => {
  return layer.getSource()?.getFeatureById(id) ?? undefined
}
